/**
 * Derive a list of badges to display on a property card / detail page
 * based on its data fields. We keep the matching loose (lowercase
 * substring) so legacy listings with free-text amenities still surface
 * the right pills.
 *
 * Returns an array of { key, label } objects. Order is meaningful:
 * Building first (structure context), then perks.
 */
export const getPropertyBadges = (property = {}) => {
  const amenities = (property.amenities || []).map((a) => String(a).toLowerCase());
  const title = String(property.title || '').toLowerCase();
  const hasAnyAmenity = (needles) =>
    amenities.some((a) => needles.some((n) => a.includes(n)));

  const badges = [];

  // "Building" — the listing is part of a multi-unit residence.
  // Driven by property_group_id, an explicit flag, OR a building
  // keyword in the title / amenities so legacy listings still surface.
  const buildingFromTitle = /residence|apartments|building|condos|complex/i.test(title);
  if (
    property.property_group_id ||
    property.is_building ||
    property.is_property_group ||
    hasAnyAmenity(['building', 'multi-unit', 'multi unit', 'residence']) ||
    buildingFromTitle
  ) {
    badges.push({ key: 'building', label: 'Building' });
  }

  // "Free breakfast" perk
  if (hasAnyAmenity(['breakfast'])) {
    badges.push({ key: 'free_breakfast', label: 'Free breakfast' });
  }

  // "Reserved Parking Spot" perk
  if (hasAnyAmenity(['parking', 'garage'])) {
    badges.push({ key: 'reserved_parking', label: 'Reserved Parking Spot' });
  }

  return badges;
};
